<template>
    <div class="stock-logo">
        <img v-if="!hasError" :src="logoUrl" :alt="stockName" @error="handleError" />
        <span v-else class="stock-logo__placeholder">{{ placeholderText }}</span>
    </div>
</template>

<script >
import { computed, onMounted, ref } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  // 股票ID
  stockId: {
    type: String,
    default: ''
  },
  // 股票名称
  stockName: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 图片是否加载失败
  const hasError = ref(false);

  // 图片 URL
  const logoUrl = computed(() => {
    if (!props.stockId) return '';
    return `https://us-quote-logo-img-1251001049.cos.na-ashburn.myqcloud.com/minilogo/${props.stockId}.jpg`;
  });

  // 占位符文本：stockName 的第一个字符
  const placeholderText = computed(() => {
    if (!props.stockName) return '';
    return props.stockName.charAt(0);
  });

  // 图片加载失败处理
  const handleError = () => {
    console.log('hasError stockId', props.stockId);
    console.log('handleError', props.stockId, props.stockName);
    hasError.value = true;
  };
  onMounted(() => {
    console.log('onMounted stockId', props.stockId);
    console.log('onMounted stockName', props.stockName);
  });
  return {
    hasError,
    logoUrl,
    placeholderText,
    handleError
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.stock-logo {
    width: 0.65rem;
    height: 0.65rem;
    border-radius: 0.325rem;
    overflow: hidden;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &__placeholder {
        font-size: 0.36rem;
        font-weight: 600;
        color: #999;
        text-transform: uppercase;
    }
}
</style>
